module.exports = __webpack_public_path__ + "static/media/KW13_pijler AS2.012b1b4f.png";